// extracted by mini-css-extract-plugin
module.exports = {"container":"StopoverRefreshing_container__1-PY_"};